// extracted by mini-css-extract-plugin
module.exports = {"dotsContainer":"Dots_dotsContainer__kaz6e","dot":"Dots_dot__1gxp2","active":"Dots_active__3m61Q"};